import { Textarea } from "@/components/ui/textarea";

interface EditableDescriptionProps { description: string; isEditing: boolean; onDescriptionChange: (d: string) => void; }

const EditableDescription = ({ description, isEditing, onDescriptionChange }: EditableDescriptionProps) =>
  isEditing ? (
    <Textarea value={description} onChange={(e) => onDescriptionChange(e.target.value)} className="text-muted-foreground resize-none mb-4" onClick={(e) => e.stopPropagation()} />
  ) : (
    <p className="text-muted-foreground mb-4">{description}</p>
  );

export default EditableDescription;
